// extracted by mini-css-extract-plugin
export var bodySections = "_cr-8";
export var gray = "_cr-7";
export var green = "_cr-4";
export var iconContainer = "_cr-9";
export var iconWidgetContainer = "_cr-1";
export var phoneIcon = "_cr-2";
export var red = "_cr-5";
export var statusDot = "_cr-3";
export var widgetContainer = "_cr-0";
export var yellow = "_cr-6";